/**
 * 公共事業場追加
 */
import Vue from 'vue'
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/public_places`

const getDefaultState = () => {
  return {}
}

const public_place = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 選択一覧
     * @param commit
     * @param state
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    show ({ commit }, { ma_manifest_id, id } ) {
      const api_path = `${API_PATH}/${id}?jwnet_manifest_id=${ma_manifest_id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        })
      })
    },
  },
  mutations: {
  },
}

export default public_place
